import { NormalizedPeriod } from "../../../../api/useTimetablePeriods";

import {
  Spinner,
  SelectTrigger,
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  Icon,
  SelectValue,
  Heading,
} from "@ogt/ui";

interface TimetableSectionProps {
  advancedMode: boolean;
  periodsLoading: boolean;
  periods: NormalizedPeriod[];
  loading: boolean;
  error: boolean;
  label?: string | null;
  fromStr: string;
  toStr: string;
  selectedPeriodId: string | null;
  setSelectedPeriodId: (id: string | null) => void;
}

function TimetableSection({
  advancedMode,
  periodsLoading,
  periods,
  loading,
  error,
  label,
  fromStr,
  toStr,
  selectedPeriodId,
  setSelectedPeriodId,
}: TimetableSectionProps) {
  return (
    <div className="flex flex-col mt-4">
      <Heading className="mb-2">Aktuell tidsperiod</Heading>

      {advancedMode ? (
        <div className="flex flex-col gap-4">
          <Select
            value={selectedPeriodId ?? undefined}
            onValueChange={(v) => setSelectedPeriodId(v)}
          >
            <SelectTrigger aria-label="Välj tidtabellsperiod">
              <SelectValue
                placeholder={
                  periodsLoading ? "Laddar perioder..." : "Välj period"
                }
              />
            </SelectTrigger>
            <SelectContent>
              <SelectGroup>
                {periods.map((p) => (
                  <SelectItem key={String(p.id)} value={String(p.id)}>
                    <div className="flex gap-2">
                      <Icon name="timetable:file-clock" />
                      {p.label ?? "Okänd"}
                    </div>
                  </SelectItem>
                ))}
              </SelectGroup>
            </SelectContent>
          </Select>

          <span className="flex items-center gap-2">
            {periodsLoading && !selectedPeriodId ? (
              <>
                <Icon name="calendar" /> Giltig: <Spinner className="h-5 w-5" />
              </>
            ) : (
              <>
                <Icon name="calendar" /> Giltig: {fromStr} till {toStr}
              </>
            )}
          </span>
        </div>
      ) : (
        <div className="flex flex-col gap-2">
          <span className="flex items-center gap-2">
            <Icon name="timetable:file-clock" />
            {loading ? (
              <>
                <Spinner className="h-5 w-5" />
                Hämtar...
              </>
            ) : error ? (
              "Okänd period"
            ) : (
              label ?? "Okänd period"
            )}
          </span>
          <span className="flex items-center gap-2">
            {loading ? (
              <>
                <Icon name="calendar" /> Giltig: <Spinner className="h-5 w-5" />
              </>
            ) : (
              <>
                <Icon name="calendar" /> Giltig: {fromStr} till {toStr}
              </>
            )}
          </span>
        </div>
      )}
    </div>
  );
}

export default TimetableSection;
